import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CodeIdChipComponent } from '../code-id-chip/code-id-chip.component';

@Component({
  selector: 'app-run-root-module',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, CodeIdChipComponent],
  template: `
    <a
      class="run-root-module"
      data-testid="run-root-module"
      [attr.href]="href()"
      [attr.aria-label]="'runRootModule.openAria' | translate: { key: moduleKey() ?? '', title: moduleTitle() ?? '' }"
      (click)="open($event)"
    >
      @if (moduleKey(); as key) {
        <app-code-id-chip [id]="key" />
      }
      <span class="run-root-module__title">{{ moduleTitle() }}</span>
    </a>
  `,
  styles: `
    :host {
      display: inline-flex;
      min-width: 0;
    }

    .run-root-module {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      min-width: 0;
      color: inherit;
      font-size: 0.8125rem;
      font-weight: 600;
      text-decoration: none;
      border-radius: 0.25rem;

      &:hover .run-root-module__title {
        text-decoration: underline;
      }

      &:focus-visible {
        outline: 2px solid var(--to-focus-ring);
        outline-offset: 2px;
      }
    }

    .run-root-module__title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `,
})
export class RunRootModuleComponent {
  private readonly router = inject(Router);

  readonly projectId = input.required<string>();
  readonly moduleId = input.required<string>();
  readonly moduleKey = input<string | null>(null);
  readonly moduleTitle = input<string | null>(null);

  private readonly commands = computed(() => ['/projects', this.projectId(), 'test-modules', this.moduleId(), 'edit']);

  readonly href = computed(() => `/projects/${this.projectId()}/test-modules/${this.moduleId()}/edit`);

  open(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    void this.router.navigate(this.commands());
  }
}
